module.exports = __webpack_public_path__ + "img/scale.1e89b66.svg";